import request from "@/utils/request";
import store from "@/store";

export function register(data) {
  return request({
    url: "/user/",
    method: "post",
    data,
  });
}

export function login(data) {
  return request({
    url: "/user/login/",
    method: "post",
    data,
  });
}

export function activation(data) {
  return request({
    url: "/user/activation/",
    method: "post",
    data,
  });
}

export function resetPassword(data) {
  return request({
    url: "/user/reset_password/",
    method: "post",
    data,
  });
}

export function resetPasswordConfirm(data) {
  return request({
    url: "/user/reset_password_confirm/",
    method: "post",
    data,
  });
}

export function resendActivation(data) {
  return request({
    url: "/user/resend_activation/",
    method: "post",
    data,
  });
}

export function getUserInfo() {
  return request({
    url: "/user/me/",
    method: "get",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
  });
}

export function submitContactData(data) {
  return request({
    url: "/user/contact/submit_data/",
    method: "post",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
    data,
  });
}

export function uploadAvatar(data) {
  return request({
    url: "/user/upload_avatar/",
    method: "post",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
    data,
  });
}

export function download(data) {
  return request({
    url: "/user/download/",
    method: "post",
    responseType: "blob",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
    data,
  });
}

export function tmApply(data) {
  return request({
    url: "/user/touch_manager/tm_apply/",
    method: "post",
    headers: { Authorization: "JWT " + store.state.user.accessToken },
    data,
  });
}
